import { decamelizeKeys, camelizeKeys } from 'humps';
import { api, endpoints } from '@dom/utils';

import { reduxDB } from '../redux';

const patchProfileEdits = async (userId, userData) => { 
  try {
    const decamelizedData = decamelizeKeys(userData);
    const { data } = await api.patch(endpoints.profile.patchUserData(userId), decamelizedData);
    reduxDB.guides.update(camelizeKeys(data));
  } catch (e) {
    console.log(e); 
  }
}

export default patchProfileEdits;
